export class CaseSearchInput {
    caseNumber: string;
    emailAddress: string;
}

export class Case {
    id: string;
    caseNumber: string;
    createdDate: string;
    status: string;
    category: string;
    subject: string;
    description: string;
    messages: CaseMessage[];
    documents: CaseDocument[];
    lines: CaseLine[];
    shipments: CaseShipment[];
}

export class CaseMessage {
    submittedDate: Date;
    submittedBy: string;
    description: string;
}

export class CaseDocument {
    name: string;
    dateAdded: string;
    fileLink: string;
}

export class CaseLine {
    line: string;
    item: string;
    description: string;
    quantityOrdered: number;
    quantityShipped: number;
}

export class CaseShipment {
    shipmentDate: string;
    carrier: string;
    trackingNumber: string;
}


// WEBPACK FOOTER //
// ./src/ts/Apps/CaseLookup/src/app/app.entities.ts